import { PgnRichText } from "~/components/pgn-rich-text/PgnRichTextView";

/** Shared saved-comment and preview presentation; source is already canonical. */
export function GameUserComment({ source, label = "Комментарий пользователя" }: { source: string; label?: "Комментарий пользователя" | "Предпросмотр" }) {
  return (
    <div
      role="region"
      aria-label={label}
      tabIndex={0}
      data-viewer-ignore-navigation="true"
      className="min-w-0 max-w-full max-h-[40vh] overflow-auto whitespace-pre-wrap [overflow-wrap:anywhere]"
      style={label === "Предпросмотр" ? undefined : { marginTop: "1lh" }}
    >
      <span>Комментарий пользователя: </span>
      <span><PgnRichText text={source} /></span>
    </div>
  );
}
